function formatNumberAbbreviated(valor, moeda = "BRL", idioma = "pt-BR") {
  const unidades = [
    { valor: 1e9, simbolo: "B" },
    { valor: 1e6, simbolo: "M" },
    { valor: 1e3, simbolo: "K" },
  ];

  for (let i = 0; i < unidades.length; i++) {
    if (valor >= unidades[i].valor) {
      const valorAbreviado = valor / unidades[i].valor;

      // Usar Intl.NumberFormat para formatar o número abreviado com a moeda correta
      const formatador = new Intl.NumberFormat(idioma, {
        style: "currency",
        currency: moeda,
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
      });

      // Usar formatToParts para construir o resultado corretamente
      const partes = formatador.formatToParts(valorAbreviado);

      // Encontrar o índice da última parte numérica (integer ou fraction)
      let ultimoIndiceNumero = -1;
      for (let j = partes.length - 1; j >= 0; j--) {
        if (partes[j].type === "integer" || partes[j].type === "fraction") {
          ultimoIndiceNumero = j;
          break;
        }
      }

      // Adicionar o símbolo de abreviação após a última parte numérica
      if (ultimoIndiceNumero >= 0) {
        partes[ultimoIndiceNumero].value += unidades[i].simbolo;
      }

      return partes.map((part) => part.value).join("");
    }
  }

  // Se o valor for menor que 1000, formata normalmente
  return new Intl.NumberFormat(idioma, {
    style: "currency",
    currency: moeda,
  }).format(valor);
}

export { formatNumberAbbreviated };
